import isNil from 'lodash/isNil';
import {AgeGrade, LayoutFragment, Maybe} from '../graphql/generated/types';
import {initializeFetchStatus} from './initializeFetchStatus.function';
import {initializeParentRelation} from './initializeParentRelation.function';
import {initializeSectionState} from './initializeSectionState.function';
import {PagewebLayoutState} from './PagewebLayoutState.interface';

/**
 * GraphQL 로부터 받은 Layout 을 redux 에 정규화해 저장합니다. 모든 초기화 프로세스를 타면서 노출(expose) 여부도 저장합니다.
 * 주의 : mutable. immer 가 적용된 경우만 사용해야함
 */
export function initializeLayoutState({
  state,
  id,
  layout,
  screenUid,
  error,
  ageGrade,
}: {
  id: string;
  state: PagewebLayoutState;
  layout?: LayoutFragment;
  screenUid: Maybe<number>;
  error?: Error;
  ageGrade?: Maybe<AgeGrade>;
}) {
  const isEnoughData = !!layout;
  initializeFetchStatus({
    state,
    id,
    isEnoughData,
    error,
  });

  if (!layout) {
    return;
  }

  const {sections, ...entity} = layout;
  state.entities.layouts[id] = {...entity, ageGrade};
  if (!isNil(screenUid)) {
    state.layoutIdAndScreenUidMap[screenUid] = id;
  }

  initializeParentRelation({
    state,
    relationKey: 'layouts',
    id,
  });
  sections?.forEach(section => {
    initializeSectionState({state, parentId: id, id: section.id, section});
  });
}
